var document = require('../internals/global').document;

module.exports = document && document.documentElement;



//////////////////
// WEBPACK FOOTER
// ../node_modules/core-js/internals/html.js
// module id = 116
// module chunks = 0